import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

/**
 * Servicio del catálogo compartido de marca (Ola 2).
 * Todo vía Cloud Functions (Admin SDK): autoriza por el claim y no depende de
 * reglas/propagación en el cliente.
 */
export const orgCatalogService = {
  /** Config de la organización (branding maestro, sharedCatalog, brandName). */
  async getOrg() {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getMyOrg');
    return (await fn()).data;
  },

  /** Sedes de la cadena (incluye catalogOverrides por sede). */
  async getMyLocations() {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getMyOrgLocations');
    return (await fn()).data; // { locations }
  },

  /** Edita el branding maestro de marca (+ flag de compartir) y materializa. */
  async updateMasterBranding({ branding, share }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-updateMasterBranding');
    return (await fn({ branding, share })).data;
  },

  /** Promueve el catálogo de una sede a maestro para un dominio (branding|menu|recipes). */
  async promoteToMaster({ sourceRestaurantId, domain }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-promoteToMaster');
    return (await fn({ sourceRestaurantId, domain })).data;
  },

  /** Marca si una sede hereda o gestiona un dominio aparte. */
  async setLocationOverride({ restaurantId, domain, override }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-setLocationCatalogOverride');
    return (await fn({ restaurantId, domain, override })).data;
  },

  /** Menú maestro de la marca (categorías + ítems). */
  async getMasterMenu() {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getMasterMenu');
    return (await fn()).data; // { categories, items }
  },

  /** CRUD del menú maestro (acciones: createCategory, updateCategory, deleteCategory, createItem, updateItem, deleteItem). */
  async manageMasterMenu(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageMasterMenu');
    return (await fn(payload)).data;
  },

  /** Override de un ítem maestro para una sede (precio/descr/imagen/ocultar; null = limpiar). */
  async setMenuItemOverride(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-setMenuItemOverride');
    return (await fn(payload)).data;
  },

  /** Activa/desactiva el compartir un dominio (menu|branding|recipes). */
  async setCatalogSharing({ domain, shared }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-setCatalogSharing');
    return (await fn({ domain, shared })).data;
  },

  /** Copia el menú de la principal a una sucursal independiente como propio (una vez, sin suscripción). */
  async copyPrimaryMenuToLocation({ restaurantId }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-copyPrimaryMenuToLocation');
    return (await fn({ restaurantId })).data;
  },

  /** Datos para mapear insumos de una sucursal con los de la principal (recetas compartidas). */
  async getInventoryLinking({ restaurantId }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getInventoryLinkingForLocation');
    return (await fn({ restaurantId })).data; // { primaryItems, localItems, summary }
  },

  /** Mapea (o desmapea) un insumo local de la sucursal con un insumo de la principal. */
  async setInventoryItemLink({ restaurantId, itemId, primaryItemId }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-setInventoryItemLink');
    return (await fn({ restaurantId, itemId, primaryItemId })).data;
  },

  /** Auto-provisiona el inventario de una sucursal copiando+mapeando los insumos de la principal. */
  async provisionInventoryFromPrimary({ restaurantId }) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-provisionInventoryFromPrimary');
    return (await fn({ restaurantId })).data;
  },
};
